import { IServerError } from "core-integration/src/store/global/types";
import { TFunction } from "i18next";
import Link from "plos/src/components/links/Link";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { contentMain } from "plos/src/layouts";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { UpdatingContent } from "./news/UpdatingContent";

interface IProps {
  error: IServerError;
}

const HomeOrHelp = () => {
  return (
    <p>
      <Trans i18nKey="homeOrHelp">
        You can return to the <Link to="/">home page</Link> and try again or{" "}
        <Link to="/help/faqs">contact us</Link> for further help.
      </Trans>
    </p>
  );
};

const renderError = (e: IServerError, t: TFunction) => {
  switch (e.code) {
    case 401:
    case 403:
      return (
        <div className={contentMain}>
          <Trans i18nKey="permissionDenied">
            <h4>Permission denied</h4>
            <p>
              Sorry, but you don't have permission to perform the request
              action.
            </p>
            <HomeOrHelp />
          </Trans>
        </div>
      );
    case 404:
      return (
        <div className={contentMain}>
          <h4>{t("pageNotFound", "Page not found")}</h4>
          <p>
            {t(
              "pageNotFoundMessage",
              "Sorry, but the page you were looking for can't be found.",
            )}
          </p>
          <HomeOrHelp />
        </div>
      );
    case 502:
    case 503:
    case 504:
      return e.details.match(/being updated/) ? (
        <UpdatingContent />
      ) : (
        <div className={contentMain}>
          <h4>{t("unavailable", "Unavailable")}</h4>
          <p>
            {t(
              "unavailableMessage",
              "Sorry, but we are unable to load the requested page at this time.",
            )}
          </p>
          <p>{t("pleaseTryAgain", "Please try again in a few minutes.")}</p>
        </div>
      );
    default:
      return (
        <div className={contentMain}>
          <h2>{t("error", "Error")}</h2>
          <p>
            {t(
              "unexpectedError",
              "Sorry, but there has been an unexpected error processing your request.",
            )}
          </p>
          <HomeOrHelp />
        </div>
      );
  }
};

const ServerError: React.FC<IProps> = ({ error }) => {
  const { t } = useTranslation();
  return <SurfaceContainer>{renderError(error, t)}</SurfaceContainer>;
};

export default ServerError;
